import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { RegistroAcessoState } from './state';

const defaultState: RegistroAcessoState = {
  registros_acesso: [],
};

export const registroAcessoModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};
